<template>
  <section>
    <TitleBlock
      :subtitle="content.subtitle"
      :title="content.title"
      :description="content.description"
      center
      :buttons="content.buttons" />
    <ul class="flex flex-col justify-center md:flex-row gap-2 md:gap-4 lg:gap-6 px-5 md:px-12.5 lg:px-25">
      <FeedCard
        v-for="(event, index) in events"
        :key="`event-index-${index}`"
        :item="event"
        class="grow basis-0 md:border-0 [&_p]:text-inherit"
        forceVertical />
    </ul>
    <OptionalButtons
      :buttons="[
        {
          label: $t('event.see_all'),
          link: eventsIndexUrl
        }
      ]"
      class="mx-auto" />
  </section>
</template>
<script lang="ts">
  import { OptionalButtons, TitleBlock } from "@/components/blocks";
  import FeedCard from "@/components/cards/FeedCard.vue";
  import { useEventStore } from "@/stores";

  export default {
    name: "FeaturedNewsSection",
    components: { FeedCard, OptionalButtons, TitleBlock },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        events: [] as Event[]
      };
    },
    computed: {
      eventsIndexUrl() {
        return (
          window.location.origin +
          this.$router.resolve({ name: `${this.$routes.EVENT.INDEX}:${this.$i18n.locale}` }).fullPath
        );
      }
    },
    async mounted() {
      const eventsStore = useEventStore();
      const now = Date.now()
        this.events = (await eventsStore.all())
          .map((event) => ({
            ...event,
            _startTimestamp: new Date(event.start_date).getTime(),
            _endTimestamp: new Date(event.end_date).getTime()
          }))
          .filter((event) => {
            return event._endTimestamp > now
          })
          .sort((eventA, eventB) => eventA._startTimestamp - eventB._startTimestamp)
          .slice(0, 3)
    }
  };
</script>
